// Sistema operativo del visitatore, per le promo che dipendono dalla piattaforma.
// nchova gira solo su Mac: sui Mac desktop gli spazi promozionali mostrano nchova al
// posto di Switcho. Lo decide lo script in linea dei partial consent-and-tags-head*,
// che scrive <html data-promo-platform> prima del primo paint; il CSS
// (css/promo-nchova.css) nasconde la variante che non vale con [data-promo-for].
// Senza attributo vale "other" (Switcho), come per il CSS.

export const PROMO_PLATFORM =
  typeof document !== 'undefined' && document.documentElement.dataset.promoPlatform === 'macos' ? 'macos' : 'other';

// true se l'elemento promo vale per questa piattaforma (senza data-promo-for vale ovunque).
export function matchesPromoPlatform(el) {
  const target = el?.dataset?.promoFor;
  return !target || target === PROMO_PLATFORM;
}
